import {isMobile} from '../../../utils/viewport';

class Animation {
    constructor() {
        this.x = 0;
        this.y = 0;

        this.width = 335;
        this.height = 251.1964;
        this.frames = 100;
        this.frame = -1;

        this.animations = [
            {
                source: `/source/${isMobile() ? 'mobile' : 'desktop'}/animations/skeleton_coins_main.png`,
                frames: 250
            },
            {
                source: `/source/${isMobile() ? 'mobile' : 'desktop'}/animations/skeleton_haha_main.png`,
                frames: 240
            }
        ];

        this.animation = 0;

        this.image = window.assets ? window.assets.images[this.animations[this.animation].source] : null;
        this.fps = 50;
        this.nextFrameTimestamp = 0;

        this.canvas = null;
        this.ctx = null;

        this.init = this.init.bind(this);
        this.draw = this.draw.bind(this);
    }

    //8k/9k

    update() {
        this.frame++;

        if(this.frame >= this.animations[this.animation].frames) {
            this.frame = 0;

            this.animation++;
            if(typeof this.animations[this.animation] === 'undefined') this.animation = 0;

            this.image = window.assets.images[this.animations[this.animation].source];
        }
    }

    draw() {
        const y = Math.floor(this.frame / 10),
              x = this.frame % 10;

        console.log(this.canvas, this.ctx);

        this.ctx.clearRect(0, 0, this.width, this.height);
        this.ctx.drawImage(
            this.image,
            (x * this.width),
            (y * this.height),
            this.width,
            this.height,
            0,
            0,
            this.width,
            this.height
        )

        this.nextFrameTimestamp = Date.now() + Math.floor(1e3 / this.fps);
    }

    animate() {
        if(Date.now() >= this.nextFrameTimestamp) {
            this.update();
            this.draw();
        }
        
        requestAnimationFrame(this.animate.bind(this));
    }

    start() {
        this.image = window.assets ? window.assets.images[this.animations[this.animation].source] : null;
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.width;
        this.canvas.height = this.height;

        this.ctx = this.canvas.getContext('2d');

        document.querySelector('.main-animation').append(this.canvas);

        requestAnimationFrame(this.animate.bind(this));
    }

    init() {
        console.log(this.animations[this.animation].source);
        this.image = window.assets ? window.assets.images[this.animations[this.animation].source] : null;
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.width;
        this.canvas.height = this.height;

        this.ctx = this.canvas.getContext('2d');

        document.querySelector('.main-animation').append(this.canvas);

        this.frame = 0;
        this.draw();
    }
}

export default new Animation();